export enum TimesInMinutes {
  minute = 1,
  hour = 60 * minute,
  day = 24 * hour,
}
